import { Form } from 'react-bootstrap';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import FormLabel from '../../../Text/FormLabel';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import StatusCheck from '../../StatusCheck';

const NewsletterSubscriptionForm = ({ apiHandler, editData }) => {
    const initialValues = {
        name: editData?.name || '',
        phone: editData?.phone || '',
        email: editData?.email || '',
        status: editData ? editData?.status : 1,
    };

    const formHandler = (formValue) => {
        if (apiHandler) {
            return apiHandler(formValue);
        }

        console.log(formValue);
        return null;
    };

    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            <Form.Group className='mt-3'>
                <FormLabel title='Name' />
                <ReactInput name='name' required />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Phone' />
                <ReactInput name='phone' required />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Email' />
                <ReactInput name='email' required />
            </Form.Group>

            <StatusCheck />
        </CrudFormLayout>
    );
};

export default NewsletterSubscriptionForm;
